/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listCustomersParamsQueryMax = 100;

export const listCustomersParamsStatusDefault = `active`;
export const listCustomersParamsCursorMax = 512;

export const listCustomersParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listCustomersParamsLimitDefault = 50;
export const listCustomersParamsLimitMax = 100;

export const ListCustomersParams = zod.object({
  query: zod.string().max(listCustomersParamsQueryMax).optional(),
  status: zod.enum(['active', 'archived']).default(listCustomersParamsStatusDefault),
  cursor: zod
    .string()
    .min(1)
    .max(listCustomersParamsCursorMax)
    .regex(listCustomersParamsCursorRegExp)
    .optional(),
  limit: zod.int().min(1).max(listCustomersParamsLimitMax).default(listCustomersParamsLimitDefault),
});

export type ListCustomersParams = zod.input<typeof ListCustomersParams>;
export type ListCustomersParamsOutput = zod.output<typeof ListCustomersParams>;
